import React from 'react';
import PropTypes from 'prop-types';
import Spinner from 'jsx/elements/spinner';
import Button from 'jsx/elements/buttons/Button';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';

const SSNTextInputBox = ({
  title,
  loading,
  onSubmit,
  onChange,
  regnoText,
  regnoTextPlaceholder,
}) => {
  const { t } = useLocale();
  const op = loading ? '0.3' : '1';
  return (
    <div>
      {loading && (
        <div style={{ position: 'relative' }}>
          <div style={{ position: 'absolute', left: '50%', top: '50px' }}>
            <Spinner size="medium" />
          </div>
        </div>
      )}
      <div style={{ opacity: op }}>
        <div className="spacing-bottom text-14">{title}</div>
        <div className="grid collapse960">
          <div className="col form s7of12">
            <textarea
              onChange={(e) => onChange('regnoText', e.target.value)}
              value={regnoText}
              placeholder={regnoTextPlaceholder || '0101302399,0101302129...'}
              style={{ resize: 'none' }}
              disabled={loading}
            />
          </div>
          <div className="col s5of12 grid collapse1080 text-right" style={{ marginTop: '45px' }}>
            <Button text={t('button_update')} color="gray" onClick={onSubmit} disabled={loading} />
          </div>
        </div>
      </div>
    </div>
  );
};

SSNTextInputBox.propTypes = {
  loading: PropTypes.bool,
  title: PropTypes.string,
  onSubmit: PropTypes.func,
  regnoText: PropTypes.string,
  onChange: PropTypes.func,
  regnoTextPlaceholder: PropTypes.string,
};

export default SSNTextInputBox;
